import { Chip, Typography, styled, type TypographyProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAnnounceChange } from '~/components/LiveRegion';
import type { RowSelectionMode } from '~/hooks/data-grid';

export const CountChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'appsValue',
})<{ selected?: boolean }>(({ theme, selected }) => ({
  position: 'relative',
  marginRight: theme.spacing(2),
  padding: theme.spacing(2),
  fontSize: '16px',
  fontWeight: selected ? 'bold' : '500',
  backgroundColor: selected ? theme.palette.primary.selected : theme.palette.common.white,
  color: selected ? theme.palette.common.white : theme.palette.common.black,
  border: '1px solid #dfdfdf',
  '&:hover': {
    background: selected && theme.palette.primary.selected,
  },
  lineHeight: theme.spacing(3),
}));

export interface SelectedCountProps extends Omit<TypographyProps, 'children'> {
  rowSelectionMode: RowSelectionMode;
  selectedCount: number;
  totalCount: number;
  thing: string;
}

export const SelectedCount = ({
  rowSelectionMode,
  selectedCount,
  totalCount,
  thing,
  ...props
}: SelectedCountProps) => {
  const { t } = useTranslation();
  const count =
    selectedCount > 0 ? (rowSelectionMode === 'page' ? selectedCount : totalCount) : totalCount;
  const text = `${count}\u00a0${t(thing, { count })}${
    selectedCount > 0 ? ` ${t('common.selected')}` : ''
  }`;
  useAnnounceChange(text);
  return (
    <Typography component="p" variant="subtitle1" {...props}>
      {text}
    </Typography>
  );
};
